// __PWA__ is injected by build.ts (Bun `define`); undefined in dev so the SW is
// never registered against the dev server. The typeof guard mirrors __API_BASE_URL__
// in apiClient.ts and avoids a ReferenceError on a bare reference.
declare const __PWA__: boolean;

// Registers the service worker and calls onUpdateReady(activate) when a new
// version has been installed and is waiting. Calling activate() applies it and
// reloads the page (via the controllerchange handler below).
export function registerServiceWorker(
  onUpdateReady: (activate: () => void) => void,
): void {
  if (typeof __PWA__ === "undefined" || !__PWA__) return;
  if (!("serviceWorker" in navigator)) return;

  const notify = (worker: ServiceWorker) => {
    onUpdateReady(() => worker.postMessage({ type: "SKIP_WAITING" }));
  };

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        // A worker updated in another tab may already be waiting.
        if (reg.waiting && navigator.serviceWorker.controller)
          notify(reg.waiting);
        reg.addEventListener("updatefound", () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener("statechange", () => {
            // Installed while an old worker still controls the page → update ready.
            if (
              installing.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              notify(installing);
            }
          });
        });
      })
      .catch(() => {
        // Registration failure is non-fatal — the app still works online.
      });
  });

  let reloading = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (reloading) return;
    reloading = true;
    window.location.reload();
  });
}
